import { IconProps } from ".";
import { Colors } from "../../styles/colors";

const TriangleIcon = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg width="105" height="91" viewBox="0 0 105 91" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.971491 90.25L52.5 1L104.029 90.25H0.971491Z"
                fill={props.color ?? Colors.darkBlue}
                stroke="black"
            />
        </svg>
    );
};

export default TriangleIcon;
